var map = {
	"./Gray/0.png": 78973,
	"./Gray/1.png": 93104,
	"./Gray/2.png": 2495,
	"./Gray/3.png": 91579,
	"./Gray/4.png": 61269,
	"./Gray/5.png": 5037,
	"./Gray/6.png": 79615,
	"./Gray/7.png": 83323,
	"./Green/0.png": 77584,
	"./Green/1.png": 54777,
	"./Green/2.png": 96695,
	"./Green/3.png": 80336,
	"./Green/4.png": 77934,
	"./Green/5.png": 88822,
	"./Green/6.png": 14855,
	"./Green/7.png": 69834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93352;